import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import Motion from '@/app/components/Motion';

import {
  PopHighlightsFeature,
  type PopHighlightsFeatureProps,
} from './PopHighlightsFeature';

export interface PopHighlightsFeatureListProps {
  readonly features: PopHighlightsFeatureProps[];
}

export function PopHighlightsFeatureList({
  features,
}: PopHighlightsFeatureListProps): JSX.Element {
  const t = useTranslations();

  return (
    <div className="mt-14">
      <Motion
        initial={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        whileInView={{ opacity: 1 }}
      >
        <TypographyV3
          className="mb-6 text-sm uppercase tracking-wider"
          Element="h3"
          weight="bold"
        >
          {t('pop_highlights_eyebrow')}
        </TypographyV3>
      </Motion>
      <LayoutGrid className="gap-6">
        {features.map((feature, i) => (
          <GridItem span={{ sm: 10, md: 24, lg: 12 }} key={feature.id}>
            <Motion
              className="h-full"
              initial={{ opacity: 0, y: 50 }}
              transition={{ delay: (i + 1) * 0.2, duration: 0.5 }}
              viewport={{ once: true }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <PopHighlightsFeature className="h-full" {...feature} />
            </Motion>
          </GridItem>
        ))}
      </LayoutGrid>
    </div>
  );
}
